export const COMPARISON_HEADER = 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.COMPARISON_TESTS';
export const COMPARISON_BASELINE_VALUE = 'INVESTIGATE_TOOLS.SUMMARY_REPORT.COMPARISON_BASELINE_VALUE';
export const COMPARISON_NO_VALUE = 'INVESTIGATE_TOOLS.SUMMARY_REPORT.NOT_APPLICABLE';

export const SUMMARY_REPORT_TABLE_HEADERS = [
  'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.DESCRIPTIVE_STATISTICS',
  'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.DISTRIBUTION',
  'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.QUARTILES',
  'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.CAPABILITY_AND_PERFORMANCE',
  COMPARISON_HEADER,
];

export const CURSOR_Y_OFFSET = 15;
export const BOXPLOT_LABEL_Z_INDEX = 5;
export const SCATTER_DOT_RADIUS = 0.7;
export const SCATTER_DOT_OVERLAY_RADIUS = 1.5;

export const SUMMARY_REPORT_TABLE_PROPS = [
  {
    key: 'average',
    label: 'STATISTICS.AVERAGE.LONG',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.DESCRIPTIVE_STATISTICS',
  },
  {
    key: 'count',
    label: 'STATISTICS.COUNT.LONG',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.DESCRIPTIVE_STATISTICS',
  },
  {
    key: 'max',
    label: 'STATISTICS.MAXIMUM.LONG',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.DESCRIPTIVE_STATISTICS',
  },
  {
    key: 'min',
    label: 'STATISTICS.MINIMUM.LONG',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.DESCRIPTIVE_STATISTICS',
  },
  {
    key: 'stdDev',
    label: 'STATISTICS.STANDARD_DEVIATION.LONG',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.DESCRIPTIVE_STATISTICS',
  },
  {
    key: 'pValue',
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.NORMAL_DISTRIBUTION_P_VALUE',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.DISTRIBUTION',
  },
  {
    key: 'minWhisker',
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.MIN_WHISKER',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.QUARTILES',
  },
  {
    key: 'quartile1',
    label: 'STATISTICS.FIRST_QUARTILE.LONG',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.QUARTILES',
  },
  {
    key: 'quartile2',
    label: 'STATISTICS.MEDIAN.LONG',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.QUARTILES',
  },
  {
    key: 'quartile3',
    label: 'STATISTICS.THIRD_QUARTILE.LONG',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.QUARTILES',
  },
  {
    key: 'maxWhisker',
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.MAX_WHISKER',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.QUARTILES',
  },
  {
    key: 'ppk',
    label: 'STATISTICS.PROCESS_PERFORMANCE_INDEX.SHORT',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.CAPABILITY_AND_PERFORMANCE',
  },
  {
    key: 'pp',
    label: 'STATISTICS.PROCESS_PERFORMANCE.SHORT',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.CAPABILITY_AND_PERFORMANCE',
  },
  {
    key: 'ppl',
    label: 'STATISTICS.PROCESS_PERFORMANCE_LOWER.SHORT',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.CAPABILITY_AND_PERFORMANCE',
  },
  {
    key: 'ppu',
    label: 'STATISTICS.PROCESS_PERFORMANCE_UPPER.SHORT',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.CAPABILITY_AND_PERFORMANCE',
  },
];

export const COMPARISON_TABLE_PROPS = [
  {
    key: 'meanPValue',
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.COMPARISON_TESTS.EQUAL_MEAN_P_VALUE',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.COMPARISON_TESTS',
  },
  {
    key: 'variancePValue',
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.COMPARISON_TESTS.EQUAL_VARIANCE_P_VALUE',
    group: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.STAT_GROUP_HEADERS.COMPARISON_TESTS',
  },
];

export enum Y_AXIS_LABEL {
  COUNT = 'COUNT',
  PERCENTAGE = 'PERCENTAGE',
}

export enum X_AXIS_LABEL {
  OFF = 'OFF',
  UNIT = 'UNIT',
}

export const X_AXIS_LABEL_OPTIONS = [
  {
    id: 'labelOff',
    value: X_AXIS_LABEL.OFF,
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.OFF',
  },
  {
    id: 'labelUnits',
    value: X_AXIS_LABEL.UNIT,
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.UNIT',
  },
];

export const Y_AXIS_LABEL_OPTIONS = [
  {
    id: 'labelCount',
    value: Y_AXIS_LABEL.COUNT,
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.COUNT',
    chartLabel: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.COUNT',
  },
  {
    id: 'labelPercentage',
    value: Y_AXIS_LABEL.PERCENTAGE,
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.PERCENTAGE',
    chartLabel: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.PERCENTAGE_SYMBOL',
  },
];

export const SUMMARY_TITLE_SHOW_HIDE_OPTIONS = [
  {
    id: 'hide',
    value: false,
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.HIDE',
  },
  {
    id: 'show',
    value: true,
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.SHOW',
  },
];

export const BOX_PLOT_POINT_LABEL_OPTIONS = [
  {
    id: 'labelOff',
    value: false,
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.OFF',
  },
  {
    id: 'labelOn',
    value: true,
    label: 'INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.LABEL.ON',
  },
];
